/* eslint-disable semi */
import Vue from 'vue';
import Router from 'vue-router';
import index from '@/pages/index';
import vipMember from '@/pages/vipMember';
Vue.use(Router);

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index
  }, {
    path: '/vipMember',
    name: 'vipMember',
    component: vipMember
  }]
});



// WEBPACK FOOTER //
// ./src/router/index.js